import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext.jsx";
import { landingApi } from "../api/landingApi.js";
import { useTranslation } from "react-i18next";
import { Eye, EyeClosed } from "lucide-react";
import RemoveBtn from "../components/RemoveBtn.jsx";

const Register = () => {

  const { t } = useTranslation();
  const [formData, setFormData] = React.useState({
    username: "",
    shopname: "",
    email: "",
    phone: "",
    township_id: "",
    district_id: "",
    password: "",
    password_confirmation: "",
    category_id: "",
    sub_category_id: "",
    businessname: "",
  });

  const { login } = useAuth();
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);
  const [townships, setTownships] = React.useState([]);
  const [districts, setDistricts] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [subCategories, setSubCategories] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();

  const usernameRef = React.useRef(null);
  const merchantnameRef = useRef(null);
  const shopnameRef = React.useRef(null);
  const emailRef = React.useRef(null);
  const phoneRef = React.useRef(null);
  const passwordRef = React.useRef(null);
  const passwordConfirmRef = React.useRef(null);
  // const businessnameRef = useRef(null);
  // const townshipRef = React.useRef(null);
  // const businessTypeRef = React.useRef(null);
  // const subBusinessTypeRef = React.useRef(null);
  // const divisionRef = React.useRef(null);

  // const [merchantname, setMerchantname] = useState("");
  // const [shopname, setShopname] = useState("");

  // const reset = (setMerchantnameFunc, merchanrtnameRef) => {
  //   setMerchantnameFunc("");
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "phone") {
  //     const numericValue = value.replace(/\D/g, "").slice(0, 11);
  //     // if (numericValue.length <= 11) {
  //     //   setFormData({
  //     //     ...formData,
  //     //     [name]: numericValue,
  //     //   });
  //     // }
  //     setFormData((prev) => ({ ...prev, phone: numericValue }));
  //     return;
  //   }
  //   // else {
  //   //   setFormData({
  //   //     ...formData,
  //   //     [name]: value,
  //   //   });
  //   // }

  //   if (name === "district_id") {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //       township_id: "",
  //     });
  //     setTownships([]);
  //   } else if (name === "category_id") {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //       sub_category_id: "",
  //     });
  //     setSubCategories([]);
  //     const selectedCategory = categories.find(
  //       (cat) => cat.id === parseInt(value),
  //     );
  //     if (selectedCategory && selectedCategory.sub_categories) {
  //       setSubCategories(selectedCategory.sub_categories);
  //     }
  //   } else {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, 11);
      setFormData((prev) => ({ ...prev, phone: numericValue }));
      return; // ← important: stop here so we don't overwrite
    }

    if (name === "district_id") {
      setFormData((prev) => ({
        ...prev,
        district_id: value,
        township_id: "",
      }));
      setTownships([]);
      return;
    }

    if (name === "category_id") {
      const selectedCategory = categories.find(
        (cat) => cat.id === parseInt(value),
      );
      setFormData((prev) => ({
        ...prev,
        category_id: value,
        sub_category_id: "",
      }));
      setSubCategories(selectedCategory?.sub_categories || []);
      return;
    }

    // default for all other fields
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleClearInput = (fieldName, ref) => {
  //   setFormData({
  //     ...formData,
  //     [fieldName]: "",
  //   });

  //   if (ref.current) {
  //     setTimeout(() => ref.current.focus(), 10);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!formData.shopname) {
      setError("Shop name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.businessname) {
      setError("Merchant name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.username) {
      setError("User name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.phone) {
      setError("Phone number is required");
      setIsLoading(false);
      return;
    }

    if (!formData.category_id) {
      setError("Category name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.district_id) {
      setError("Division name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.township_id) {
      setError("Township name is required");
      setIsLoading(false);
      return;
    }

    if (!formData.password) {
      setError(t("password is required"));
      setIsLoading(false);
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      setError(t("passwordsDoNotMatch"));
      setIsLoading(false);
      return;
    }

    const payload = {
      ...formData,
      category_id: Number(formData.category_id),
      sub_category_id: Number(formData.sub_category_id),
      district_id: Number(formData.district_id),
      township_id: Number(formData.township_id),
    };

    console.log("payload:", payload);

    try {
      const response = await landingApi.registerMerchant(payload);
      console.log("payload:", payload);
      if (!response) {
        throw new Error(t("noResponseFromServer"));
      }
      let responseData;
      try {
        responseData = response.data;
      } catch (error) {
        console.error("Response parsing error:", error);
        throw new Error(t("invalidServerResponse"));
      }
      if (!response.status === 200) {
        if (responseData.errors) {
          const errorMessages = Object.entries(responseData.errors).map(
            ([field, messages]) => `${field}: ${messages.join(", ")}`,
          );
          setError(errorMessages.join("\n"));
        } else {
          setError(responseData.message || t("registrationFailed"));
        }
        setIsLoading(false);
        return;
      }
      setSuccess(true);
      login({
        token: responseData.token,
        user: {
          ...responseData.user,
          shopname: responseData.merchant.name,
          merchantid: responseData.merchant.id,
        },
      });
      setTimeout(() => navigate("/"), 1500);
    } catch (error) {
      console.error("Registration error:", error);
      setError(error.message || t("networkError"));
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const raw = await landingApi.getDistricts();
        console.log("[DEBUG] getDistricts raw:", JSON.stringify(raw).substring(0, 300));
        const list = Array.isArray(raw) ? raw : raw?.data || raw?.districts || raw?.result || [];
        console.log("[DEBUG] getDistricts parsed:", Array.isArray(list) ? list.length : typeof list);
        setDistricts(Array.isArray(list) ? list : []);
      } catch (error) {
        console.error("[DEBUG] Error fetching districts: ", error);
        setDistricts([]);
      }
    };
    fetchDistricts();
  }, []);

  React.useEffect(() => {
    const fetchCategories = async () => {
      try {
        const raw = await landingApi.getCategoriesPublic();
        console.log("[DEBUG] getCategories raw:", JSON.stringify(raw).substring(0, 300));
        const list = Array.isArray(raw) ? raw : raw?.data || raw?.categories || raw?.result || [];
        console.log("[DEBUG] getCategories parsed:", Array.isArray(list) ? list.length : typeof list);
        setCategories(Array.isArray(list) ? list : []);
      } catch (error) {
        console.error("[DEBUG] Error fetching categories: ", error);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);

  React.useEffect(() => {
    const fetchTownships = async () => {
      if (!formData.district_id) {
        setTownships([]);
        return;
      }

      try {
        const raw = await landingApi.getTownships(formData.district_id);
        const list = Array.isArray(raw) ? raw : raw?.data || raw?.townships || raw?.result || [];
        setTownships(Array.isArray(list) ? list : []);
      } catch (error) {
        console.error("Error fetching townships: ", error);
      }
    };
    fetchTownships();
  }, [formData.district_id]);

  return (
    // <section id="register" className="py-5 bg-gray-50">
    //   <div className="max-w-3xl mx-auto px-4">
    //     <h2 className="text-xl font-bold text-center text-gray-800 mb-5">
    //       Merchant Registration
    //     </h2>
    //     <form
    //       onSubmit={handleSubmit}
    //       className="bg-white shadow-lg rounded-lg p-8 space-y-6 "
    //     >
    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("merchantName")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={businessnameRef}
    //               type="text"
    //               placeholder={t("merchantName")}
    //               name="businessname"
    //               value={formData.business}
    //               onChange={handleChange}
    //               autoComplete="off"
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.business && (
    //               <button
    //                 type="button"
    //                 onClick={() =>
    //                   handleClearInput("businessname", businessnameRef)
    //                 }
    //                 className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 shadow-md rounded-full"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>

    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("shopName")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={shopnameRef}
    //               type="text"
    //               placeholder={t("shopName")}
    //               name="shopname"
    //               value={formData.shopname}
    //               onChange={handleChange}
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.shopname && (
    //               <button
    //                 type="button"
    //                 onClick={() => handleClearInput("shopname", shopnameRef)}
    //                 className="absolute shadow-md rounded-full right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>
    //       </div>

    //       <div className="w-1/2">
    //         <label
    //           htmlFor=""
    //           className="block text-sm font-medium text-gray-700 mb-1"
    //         >
    //           User Name
    //           <span className="text-red-500">*</span>
    //         </label>
    //         <div className="relative">
    //           <input
    //             type="text"
    //             placeholder="User Name"
    //             name="username"
    //             value={formData.username}
    //             onChange={handleChange}
    //             className="border border-gray-300 p-3 rounded w-full outline-none"
    //           />
    //           {formData.username && (
    //             <button
    //               type="button"
    //               onClick={() => handleClearInput("username", usernameRef)}
    //               className=" absolute shadow-md rounded-full right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //             >
    //               <svg
    //                 className="w-5 h-5"
    //                 fill="none"
    //                 stroke="currentColor"
    //                 viewBox="0 0 24 24"
    //               >
    //                 <path
    //                   strokeLinecap="round"
    //                   strokeLinejoin="round"
    //                   strokeWidth={2}
    //                   d="M6 18L18 6M6 6l12 12"
    //                 />
    //               </svg>
    //             </button>
    //           )}
    //         </div>
    //       </div>

    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("emailAddress")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={emailRef}
    //               type="email"
    //               placeholder={t("emailAddress")}
    //               name="email"
    //               value={formData.email}
    //               onChange={handleChange}
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.email && (
    //               <button
    //                 type="button"
    //                 onClick={() => handleClearInput("email", emailRef)}
    //                 className="absolute shadow-md rounded-full right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>

    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("phoneNumber")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={phoneRef}
    //               type="string"
    //               placeholder={t("phoneNumber")}
    //               name="phone"
    //               value={formData.phone}
    //               onChange={handleChange}
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.phone && (
    //               <button
    //                 type="button"
    //                 onClick={() => handleClearInput("phone", phoneRef)}
    //                 className="absolute shadow-md rounded-full right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>
    //       </div>

    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("businessType")} <span className="text-red-500">*</span>
    //           </label>
    //           <select
    //             name="category_id"
    //             value={formData.category_id}
    //             onChange={handleChange}
    //             className="border border-gray-300 cursor-pointer p-3 rounded w-full outline-none"
    //             required
    //           >
    //             <option value="">{t("selectCategory")}</option>
    //             {categories.map((category) => (
    //               <option key={category.id} value={category.id}>
    //                 {category.name}
    //               </option>
    //             ))}
    //           </select>
    //         </div>

    //         {subCategories.length > 0 && (
    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-1">
    //               {t("subBusinessType")}
    //             </label>
    //             <select
    //               name="sub_category_id"
    //               value={formData.sub_category_id}
    //               onChange={handleChange}
    //               className="border border-gray-300 cursor-pointer p-3 rounded w-full outline-none"
    //             >
    //               <option value="">{t("selectSubCategory")}</option>
    //               {subCategories.map((subCategory) => (
    //                 <option key={subCategory.id} value={subCategory.id}>
    //                   {subCategory.name}
    //                 </option>
    //               ))}
    //             </select>
    //           </div>
    //         )}
    //       </div>

    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("division")} <span className="text-red-500">*</span>
    //           </label>
    //           <select
    //             name="district_id"
    //             value={formData.district_id}
    //             onChange={handleChange}
    //             className="border border-gray-300 cursor-pointer p-3 rounded w-full outline-none"
    //             required
    //           >
    //             <option value="">{t("selectDivision")}</option>
    //             {districts.map((district) => (
    //               <option key={district.id} value={district.id}>
    //                 {district.name}
    //               </option>
    //             ))}
    //           </select>
    //         </div>

    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("township")} <span className="text-red-500">*</span>
    //           </label>
    //           <select
    //             name="township_id"
    //             value={formData.township_id}
    //             onChange={handleChange}
    //             className="border border-gray-300 cursor-pointer p-3 rounded w-full outline-none"
    //             required
    //           >
    //             <option value="">{t("selectTownship")}</option>
    //             {townships.map((township) => (
    //               <option key={township.id} value={township.id}>
    //                 {township.name}
    //               </option>
    //             ))}
    //           </select>
    //         </div>
    //       </div>

    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("password")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={passwordRef}
    //               type="password"
    //               name="password"
    //               placeholder={t("password")}
    //               value={formData.password}
    //               onChange={handleChange}
    //               autoComplete="new-password"
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.password && (
    //               <button
    //                 type="button"
    //                 onClick={() => handleClearInput("password", passwordRef)}
    //                 className="absolute shadow-md rounded-full right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>

    //         <div className="relative">
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             {t("confirmPassword")} <span className="text-red-500">*</span>
    //           </label>
    //           <div className="relative">
    //             <input
    //               ref={passwordConfirmRef}
    //               type="password"
    //               name="password_confirmation"
    //               placeholder={t("confirmPassword")}
    //               value={formData.password_confirmation}
    //               onChange={handleChange}
    //               autoComplete="new-password"
    //               className="border border-gray-300 p-3 rounded w-full outline-none"
    //               required
    //             />
    //             {formData.password_confirmation && (
    //               <button
    //                 type="button"
    //                 onClick={() =>
    //                   handleClearInput(
    //                     "password_confirmation",
    //                     passwordConfirmRef,
    //                   )
    //                 }
    //                 className="absolute right-3 shadow-md rounded-full top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
    //               >
    //                 <svg
    //                   className="w-5 h-5"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     strokeLinecap="round"
    //                     strokeLinejoin="round"
    //                     strokeWidth={2}
    //                     d="M6 18L18 6M6 6l12 12"
    //                   />
    //                 </svg>
    //               </button>
    //             )}
    //           </div>
    //         </div>
    //       </div>

    //       <button
    //         type="submit"
    //         disabled={isLoading}
    //         className={`
    //           bg-black text-white px-6 py-3 rounded-lg w-full text-center
    //           font-medium
    //           transition-all duration-300 ease-in-out
    //           hover:bg-gray-800 hover:shadow-lg hover:scale-[1.02]
    //           active:scale-[0.98]
    //           disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none
    //           ${isLoading ? "cursor-wait" : ""}
    //         `}
    //       >
    //         {isLoading ? (
    //           <span className="flex items-center justify-center">
    //             <svg
    //               className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
    //               xmlns="http://www.w3.org/2000/svg"
    //               fill="none"
    //               viewBox="0 0 24 24"
    //             >
    //               <circle
    //                 className="opacity-25"
    //                 cx="12"
    //                 cy="12"
    //                 r="10"
    //                 stroke="currentColor"
    //                 strokeWidth="4"
    //               ></circle>
    //               <path
    //                 className="opacity-75"
    //                 fill="currentColor"
    //                 d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    //               ></path>
    //             </svg>
    //             {t("processing")}
    //           </span>
    //         ) : (
    //           t("createAccount")
    //         )}
    //       </button>

    //       {error && (
    //         <div className="text-red-500 text-center whitespace-pre-line bg-red-50 p-3 rounded">
    //           {error}
    //         </div>
    //       )}

    //       {success && (
    //         <div className="text-green-500 text-center bg-green-50 p-3 rounded">
    //           {t("registrationSuccess")}
    //         </div>
    //       )}
    //     </form>
    //   </div>
    // </section>
    <section id="register">
      <div className="flex flex-1 mx-10 gap-20">
        <div className="flex flex-1 m-10 my-36 bg-primary-color rounded-3xl shadow-md">
          <div className="px-10  py-40 text-white space-y-5">
            <h1 className="text-3xl font-bold">Welcome to Zayverse</h1>
            <p className="text-xl">
              Empowering your brand with the tools you need to succeed.
            </p>
          </div>
        </div>
        <div className="flex flex-1 m-10 rounded-3xl border shadow-md">
          <div className="flex flex-col px-10 py-5 gap-0 flex-1">
            <h1 className=" text-2xl font-bold text-center my-3">
              Merchant Registration
            </h1>
            <form action="" onSubmit={handleSubmit}>
              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Merchant Name
                  <span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="businessname"
                  value={formData.businessname}
                  onChange={handleChange}
                  ref={merchantnameRef}
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.businessname && (
                  <RemoveBtn
                    setValue={(value) =>
                      setFormData((prev) => ({ ...prev, businessname: value }))
                    }
                    inputRef={merchantnameRef}
                  />
                )}
              </div>
              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Shop Name<span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="shopname"
                  value={formData.shopname}
                  onChange={handleChange}
                  ref={shopnameRef}
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.shopname && (
                  <RemoveBtn
                    setValue={(value) =>
                      setFormData((prev) => ({ ...prev, shopname: value }))
                    }
                    inputRef={shopnameRef}
                  />
                )}
              </div>
              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3 ">
                  User Name<span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="username"
                  id=""
                  value={formData.username}
                  onChange={handleChange}
                  ref={usernameRef}
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.username && (
                  <RemoveBtn
                    setValue={(value) =>
                      setFormData((prev) => ({ ...prev, username: value }))
                    }
                    inputRef={usernameRef}
                  />
                )}
              </div>

              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Phone Number<span className="text-red-500">*</span>
                </span>
                <input
                  type="tel"
                  value={formData.phone}
                  ref={phoneRef}
                  onChange={handleChange}
                  name="phone"
                  id="phone"
                  maxLength="11"
                  inputMode="numeric"
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.phone && (
                  <div className="absolute right-6 top-0">
                    <RemoveBtn
                      setValue={(value) =>
                        setFormData((prev) => ({ ...prev, phone: value }))
                      }
                      inputRef={phoneRef}
                    />
                  </div>
                )}
              </div>

              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Email Address
                </span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  ref={emailRef}
                  id=""
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.email && (
                  <RemoveBtn
                    setValue={(value) =>
                      setFormData((prev) => ({ ...prev, email: value }))
                    }
                    inputRef={emailRef}
                  />
                )}
              </div>
              <div className="flex flex-1 p-3">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Business Type<span className="text-red-500">*</span>
                </span>
                <select
                  name="category_id"
                  onChange={handleChange}
                  value={formData.category_id}
                  id=""
                  className="border border-black px-3 py-1 outline-none w-2/3 cursor-pointer"
                >
                  <option value="" disabled>
                    Please select your Business Type
                  </option>
                  {categories.map((c) => (
                    <option value={c.id} key={c.id}>
                      {" "}
                      {c.name}{" "}
                    </option>
                  ))}
                </select>
              </div>
              {subCategories.length > 0 && (
                <div className="flex flex-1 p-3">
                  <span className="bg-gray-500 px-3 py-1 text-white w-1/3  ">
                    Sub Business Type
                  </span>
                  <select
                    name="sub_category_id"
                    id=""
                    value={formData.sub_category_id}
                    onChange={handleChange}
                    className="border border-black px-3 py-1 outline-none w-2/3 cursor-pointer"
                  >
                    <option value="" disabled>
                      Please select your Sub Category
                    </option>
                    {subCategories.map((sc) => (
                      <option value={sc.id} key={sc.id}>
                        {sc.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="flex flex-1 p-3">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3 ">
                  Division<span className="text-red-500">*</span>
                </span>
                <select
                  name="district_id"
                  id=""
                  value={formData.district_id}
                  onChange={handleChange}
                  className=" cursor-pointer w-2/3 outline-none border border-black px-3"
                >
                  <option value="" disabled>
                    Please select your Division
                  </option>
                  {districts.map((d) => (
                    <option value={d.id} key={d.id}>
                      {" "}
                      {d.name}{" "}
                    </option>
                  ))}
                </select>
              </div>
              {formData.district_id && (
                <div className="flex flex-1 p-3">
                  <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                    Township<span className="text-red-500">*</span>
                  </span>
                  <select
                    name="township_id"
                    id=""
                    value={formData.township_id}
                    onChange={handleChange}
                    className=" cursor-pointer w-2/3 outline-none border border-black px-3"
                  >
                    <option value="" disabled>
                      Please select your Township
                    </option>
                    {townships.map((t) => (
                      <option value={t.id} key={t.id}>
                        {" "}
                        {t.name}{" "}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="flex flex-1 p-3 relative">
                <span className="bg-gray-500 px-3 py-1 text-white w-1/3">
                  Password<span className="text-red-500">*</span>
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  value={formData.password}
                  onChange={handleChange}
                  ref={passwordRef}
                  className="border px-3 py-1 border-black outline-none w-2/3"
                />
                {formData.password && (
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="text-gray-500 hover:text-gray-700 focus:outline-none p-0 bg-transparent border-none h-6 w-6 flex items-center justify-center absolute bottom-15 right-8"
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? (
                        <Eye size={18} />
                      ) : (
                        <EyeClosed size={18} />
                      )}
                    </button>
                    <div className="absolute bottom-6 left-0">
                      <RemoveBtn
                        setValue={(value) =>
                          setFormData((prev) => ({ ...prev, password: value }))
                        }
                        inputRef={passwordRef}
                        // className="relative right-0 top-0 h-6 w-6 p-0 border-none bg-transparent custom-shadow-effect-none"
                      />
                    </div>
                  </div>
                )}
              </div>
              {formData.password && (
                <div className="flex flex-1 p-3 relative">
                  <span className="bg-gray-500 ps-3 py-1 text-white w-1/3">
                    Password Confirmation<span className="text-red-500">*</span>
                  </span>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="password_confirmation"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                    ref={passwordConfirmRef}
                    className="border px-3 py-1 border-black outline-none w-2/3"
                  />
                  {formData.password_confirmation && (
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                      <button
                        type="button"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        className="text-gray-500 hover:text-gray-700 focus:outline-none p-0 bg-transparent border-none absolute bottom-15 right-9"
                      >
                        {showConfirmPassword ? (
                          <Eye size={18} />
                        ) : (
                          <EyeClosed size={18} />
                        )}
                      </button>
                      <div className="absolute bottom-6 left-0">
                        <RemoveBtn
                          setValue={(value) =>
                            setFormData((prev) => ({
                              ...prev,
                              password_confirmation: value,
                            }))
                          }
                          inputRef={passwordConfirmRef}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="flex flex-1 justify-center my-5">
                <button
                  className=" custom-darkblue-button text-white w-1/2"
                  type="submi"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      {t("processing")}
                    </span>
                  ) : (
                    t("createAccount")
                  )}
                </button>

                {error && (
                  <div className="text-red-500 text-center whitespace-pre-line bg-red-50 p-3 rounded">
                    {error}
                  </div>
                )}

                {success && (
                  <div className="text-green-500 text-center bg-green-50 p-3 rounded">
                    {t("registrationSuccess")}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
